import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup";
import Success from "./pages/Success";
import SelectPlace from "./pages/SelectPlace";
import PasswordProtectedList from "./pages/PasswordProtectedList";
import ClosedSignup from "./pages/ClosedSignup";
import ClosedSignupENSSEA from "./pages/ClosedSignupENSSEA";

function App() {
  return (
    <Routes>
      <Route path="*" element={<div> 404 </div>} />
      <Route path="/" element={<SelectPlace />} />

      <Route path="/bab-ezzouar" element={<ClosedSignup />} />
      <Route path="/sablette2" element={<ClosedSignup />} />
      <Route path="/alger" element={<Signup />} />
      <Route path="/Zeralda" element={<ClosedSignup />} />
      <Route path="/blida" element={<ClosedSignup />} />
      <Route path="/oran" element={<ClosedSignup />} />
      {/* <Route path="/enssea" element={<ClosedSignupENSSEA />} /> */}

      <Route path="/success" element={<Success />} />
      <Route path="/list" element={<PasswordProtectedList />} />
    </Routes>
  );
}

export default App;
